import { ActiveFilterChip } from '../../../../components/list';
import { PromotionScheduleListFilter } from '../../../../lib/api/promotionSchedule';
import { MANAGER_UNASSIGNED_VALUE, STATUS_LABEL, TRACK_META, TYPE_LABEL } from '../constants';

/**
 * 적용된 필터 → 칩 (AMZUWEB-682).
 *
 * 검색 박스는 스크롤 밖으로 나가는데 표는 남는다. 남이 보낸 링크를 연 사람은
 * **어떤 조건이 걸려 있는지 모른 채 표부터 보므로**, 표 위에 지금 조건을 항상 보여 준다.
 *
 * 담당자는 id 만 있고 이름은 여기 없다(별도 조회) — 이름까지 담으려면 이 유틸이
 * 조회에 의존하게 되므로 건수로 요약한다.
 */
export const buildScheduleFilterChips = (filter: PromotionScheduleListFilter): ActiveFilterChip[] => {
  const chips: ActiveFilterChip[] = [];

  if (filter.from || filter.to) {
    chips.push({ key: 'period', label: `기간 ${filter.from ?? ''} ~ ${filter.to ?? ''}` });
  }

  if (filter.tracks?.length) {
    chips.push({
      key: 'tracks',
      label: `트랙 ${filter.tracks.map((track) => TRACK_META[track]?.label ?? track).join(', ')}`,
    });
  }

  if (filter.statuses?.length) {
    chips.push({
      key: 'statuses',
      label: `상태 ${filter.statuses.map((status) => STATUS_LABEL[status]).join(', ')}`,
    });
  }

  if (filter.types?.length) {
    chips.push({ key: 'types', label: `유형 ${filter.types.map((type) => TYPE_LABEL[type]).join(', ')}` });
  }

  if (filter.adminIds?.length) {
    const hasUnassigned = filter.adminIds.includes(MANAGER_UNASSIGNED_VALUE);
    const assignedCount = filter.adminIds.filter((id) => id !== MANAGER_UNASSIGNED_VALUE).length;

    const parts = [assignedCount > 0 ? `${assignedCount}명` : null, hasUnassigned ? '미지정' : null].filter(Boolean);

    chips.push({ key: 'adminIds', label: `담당자 ${parts.join(' + ')}` });
  }

  // `false` 가 의미 있는 값이라 존재 여부로 판단한다 (빈 값 체크로 거르면 "미연결" 이 사라진다)
  if (filter.hasEvent !== undefined) {
    chips.push({ key: 'hasEvent', label: `기획전 ${filter.hasEvent ? '연결됨' : '미연결'}` });
  }

  if (filter.hasCoupon !== undefined) {
    chips.push({ key: 'hasCoupon', label: `쿠폰 ${filter.hasCoupon ? '연결됨' : '미연결'}` });
  }

  if (filter.keyword) {
    chips.push({ key: 'keyword', label: `검색어 "${filter.keyword}"` });
  }

  return chips;
};
